import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import getEmailDistributionList from '../../../functions/getEmailDistributionList';

const useStyles = makeStyles(() => ({
  root: {
    color: '#FFFFFF',
    backgroundColor: '#006bb6',
    '&:hover': {
      backgroundColor: '#006bb6',
      filter: 'brightness(90%)',
    },
  },
}));

const EMAIL_BODY_TEMPLATE =
  '<Please attach resume, cover letter, and any other relevant information to this email.>';

const ApplyButton = ({ jobId, jobTitle }) => {
  const classes = useStyles();

  const emailSubject = `Application for ${jobTitle} (${jobId})`;
  const emailDistributionList =
    getEmailDistributionList()?.recipients?.toString();
  const mailtoLink = `mailto:${emailDistributionList}?subject=${emailSubject}&body=${EMAIL_BODY_TEMPLATE}`;

  return (
    <Button
      className={classes.root}
      href={mailtoLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      Apply
    </Button>
  );
};

ApplyButton.defaultProps = {
  jobId: '<Job Id>',
  jobTitle: '<Job Title>',
};

ApplyButton.propTypes = {
  jobId: PropTypes.string,
  jobTitle: PropTypes.string,
};

export default ApplyButton;
